import axios from "axios";
import _ from "lodash";
import { WP_ENDPOINT, WP_LIBRARY_ALBUMS} from ".././config";

export default async function fetchBook(albumId) {
	let album = await axios.get(WP_ENDPOINT + WP_LIBRARY_ALBUMS + '/' + albumId , {
		params: {fields:'acf'}
	});

	album.data.acf.photos = _.map(album.data.acf.photos, photo => {
		return {
			src: photo.url,
         	thumbnail: photo.sizes.medium,
          	w: photo.width,
        	h: photo.height
		}
	})



	return album.data.acf;
}


// WEBPACK FOOTER //
// ./src/store/services/LibraryAlbum/index.js